import React from 'react'
import {Box,Text,Clock,Layer,Spinner,Button,DataTable,Heading } from 'grommet'
import moment from 'moment';
import {Organization,Cube,ThreeD,Currency,Notes } from 'grommet-icons';
import NewShipmentRequest from '../newShipmentRequest.json'
import {Link } from 'react-router-dom';
import { FormNext } from 'grommet-icons';

export function ReturnGreeting(user, hour){
    if (hour < 12){
      return `Good Morning, ${user}`
    } else {
      return `Good Afternoon, ${user}`
    }
  }

export function isShipmentCollected(shipment){
  if (shipment.status !== 'Awaiting Pickup'){
    return true
  } else {
    return false
  }
}
  
export function ReturnDropdownLocationOptions(locations){
  // locations.forEach(location => {
  //   location.dropdown_element = <Box direction='row'><Text margin='xsmall'>{location.name}</Text><Tag margin={{left: 'xsmall'}} background='status-ok' value={location.location_type} /></Box>
  // })
  return locations
}

 export function ReturnDateTimeClock(){
    return (
      <Box direction='row' margin='small' background='background-front' elevation='large' round>
            <Text size='small' margin='small' style={{marginTop: 17}}>{moment().format("dddd, MMMM Do YYYY")}</Text>
            <Clock type="digital" margin='small' size='small' style={{marginTop: 17}}/>
      </Box>
    )
  }

  export function RichTabTitle({icon, label}){
    return (
    <Box direction="row" align="center" gap="xsmall" margin="xsmall">
      {icon}
      <Text size="small">
        <strong>{label}</strong>
      </Text>
    </Box>
    )
  }

  export function DisplayCompanyName(labName, newLabName){
    if (labName === newLabName){
      return null
    } else {
      return <Box direction='row'><Organization style={{marginLeft:-11}} /><Text style={{marginLeft: 5, marginTop: 5}} size='small'><strong>{newLabName}</strong></Text></Box>
    }
  }

  export function ReturnRowDir(size){
    if (size === 'small' || size === 'medium'){
      return 'column'
    } else {
      return 'row'
    }
  }

  export function ShipmentDetails(fields,shipmentPieceDetails,origin){
    var date = moment(fields.collectionDate).format("YYYY-MM-DD");
    var dateTime = moment(date + " " + fields.collectionTime).format("YYYY-MM-DDTHH:mm:ss[GMT]Z")
    NewShipmentRequest.shipment.pieces.PickupDateTime = dateTime;
    NewShipmentRequest.shipment.pieces.RequestPickup = fields.requestPickup;
    NewShipmentRequest.shipment.pieces.PickupCloseTime = fields.pickupCloseTime;
    NewShipmentRequest.shipment.pieces.PickUpLocation = fields.pickupLocation;
    NewShipmentRequest.shipment.pieces.TotalWeight = fields.weight
    NewShipmentRequest.shipment.pieces.TotalPieces = shipmentPieceDetails.length
    NewShipmentRequest.shipment.pieces.TermsOfTrade = fields.termsOfTrade
    NewShipmentRequest.shipment.pieces.CustomerPO = fields.customerPO
    NewShipmentRequest.shipment.pieces.Packages = ReturnPackages(shipmentPieceDetails, origin)
  }


  export function ReturnPackages(pieces, originCountry){
    var packages = []
    pieces.map((piece, i) => {
     var item = {
      Number: i + 1, 
      Weight: piece.weight, 
      Dimensions: {
        Length: piece.length,
        Width: piece.width,
        Height: piece.height
      },
      Commodity: piece.commodity.name,
      CommodityCode: piece.commodity.code, 
      CommodityID: piece.commodity.id,
      CustomsValue: piece.customsValue,
      Quantity: 1, 
      QuantityUnitOfMeasure: "KG", 
      ItemDescription: piece.commodity.description,
      UnitPrice: piece.customsValue,
      NetWeight: piece.weight, 
      GrossWeight: piece.weight, 
      ManufacturingOrigin: originCountry,
      PieceReference: piece.pieceRef
     }
     packages.push(item)
     return item
    })
    return packages
  }

  export function PieceDetailsCheck(piece,firstQuote){
    var isEmpty;
    var shipmentPieces = piece
    if (firstQuote){
      shipmentPieces.forEach(p => {
        delete p.number
        Object.values(p).forEach(x => {
          if (x === null || x === ''){
            isEmpty = false
          } else {
            isEmpty = true
          }
        })
      })
    } else {
      isEmpty = true
    }
    return isEmpty
  }

  export function ReturnQuote(value, dims, origin, destination){
    var date = moment(value.collectionDate).format("YYYY-MM-DD");
    var dateTime = moment(date + " " + value.collectionTime).format("YYYY-MM-DDTHH:mm:ss[GMT]Z")
    var formattedQuote = {category: 'new_quick_quote_request', user: sessionStorage.getItem('username'), quoted_weight: 0, origin:{}, destination: {}, transit_details: {}}
    formattedQuote.origin.country = origin.country
    formattedQuote.origin.city = origin.city
    formattedQuote.origin.postcode = origin.postcode
    formattedQuote.destination.country = destination.country
    formattedQuote.destination.city = destination.city
    formattedQuote.destination.postcode = destination.postcode
    formattedQuote.transit_details.Packages = ReturnPackages(dims, value.commodity)
    formattedQuote.transit_details.PickupDateTime = dateTime
    formattedQuote.quoted_weight = ReturnTotalWeight(formattedQuote)
    return formattedQuote
  }
  
 export function ReturnTotalWeight(quote){
    let weight = 0;
    quote.transit_details.Packages.forEach(pack => {
        var a = parseFloat(pack.Weight)
        weight += a
    })
    return weight
  }

export  const LoadLayer = (props) => {
  if (props.load){
    return (
      <Layer>
      <Box rounded height='small' align="center" justify="center" gap="small" direction="column" alignSelf="center" pad="large">
          <Box direction='row'><Spinner color='brand' size='medium' weight='bold' /><Text margin='small' style={{marginLeft:20}}>{props.label}</Text></Box>  
      </Box>
      </Layer>
     )
  } else {
    return null
  }
}  


export  const TableLoadLayer = (props) => {
  if (props.load){
    return (
      <DataTable   
        background={{
          header: { color: '#18445C'},
          footer: { color: 'dark-3', opacity: 'strong' },
        }}
        step={10}
        style={{height: 200}}
        placeholder={
        <Box fill align="center" justify="center" direction="row" pad="large" gap="small" >
          <Spinner color='brand' size='medium' weight='bold' />
          <Text>{props.label}</Text>       
      </Box>
        }
      />
     )
  } else {
    return null
  }
}  

export function ReturnNavigationBaseUrl(page,user){
  if (user === 'SuperAdmin'){
    if (page.name.includes("Quote")){
      return ""
    } else 
    { 
      return '/admin'
    }
  } else {
    return ''
  }
}

export function PostalCodeRequired (country){
  if (country === ""){
    return true
  } else {
    var exemptCountries = ['AE', 'AF', 'AG', 'AI', 'AL', 'AN', 'AO', 'AW', 'BB', 'BF', 'BH', 'BI', 'BJ', 'BM', 'BO', 'BS', 'BT', 'BW', 'BZ', 'CD', 'CF', 'CG', 'CI', 'CK', 'CL', 'CM', 'CO', 'CR', 'CV', 'DJ', 'DM', 'DO', 'EC', 'EG', 'ER', 'ET', 'FJ', 'FK', 'GA', 'GD', 'GH', 'GI', 'GM', 'GN', 'GQ', 'GT', 'GW', 'GY', 'HK', 'HN', 'HT', 'IE', 'IQ', 'IR', 'JM', 'JO', 'KE', 'KH', 'KI', 'KM', 'KN', 'KP', 'KW', 'KY', 'LA', 'LB', 'LC', 'LK', 'LR', 'LS', 'LY', 'ML', 'MM', 'MO', 'MR', 'MS', 'MT', 'MU', 'MW', 'MZ', 'NA', 'NE', 'NG', 'NI', 'NP', 'NR', 'NU', 'OM', 'PA', 'PE', 'PF', 'PY', 'QA', 'RW', 'SA', 'SB', 'SC', 'SD', 'SL', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SY', 'TC', 'TD', 'TG', 'TL', 'TO', 'TT', 'TV', 'TZ', 'UG', 'UY', 'VC', 'VE', 'VG', 'VN', 'VU', 'WS', 'XA', 'XB', 'XC', 'XE', 'XL', 'XM', 'XN', 'XS', 'YE', 'ZM', 'ZW',]
    if (exemptCountries.includes(country)){
      return false
    } else {
      return true
    }
  }
}

export function NavigationSnackBar(props){
  return(
  <Box border='bottom' direction='row' justify='between'>
    
    <Box direction='row' margin='small' >
      {props.pages.map((page,i) => {
        return (
          <Box align='center' direction='row'>
          {page.link ? <Link hoverIndicator style={{color:'inherit', fontSize: 15, textDecoration: 'none',margin:12,fontWeight: 'bold'}} to={`${ReturnNavigationBaseUrl(page,props.user)}${page.link}`}><Button elevation='large' primary hoverIndicator fontWeight='bold' size='small' label={page.name}/></Link>: <Text size='small' style={{marginTop: 1}} margin={{left: 'small', right:'small'}} weight='bold'>{page.name}</Text> }
          {(i + 1 === props.pages.length) ? null : <FormNext style={{margin:11, marginRight:-15,marginLeft:-15}} color='#18445C' />}
          </Box>
        )
      })}
      </Box>
      <Box direction='row'>
        <Heading justify='center' margin={{right:'medium'}} level={3}>
          {props.title}
        </Heading>
      </Box>
      {/* <Box direction='row'>
        <ReturnDateTimeClock />
        </Box> */}
    </Box>
  )
}

export const ReturnAddress = (address, addressType, methodType, labId) => {
  let newAddress = address
  let templateAddress
  if (addressType === 'addressBook'){
     templateAddress = {AddressLineOne: newAddress.address_line_one, AddressLineTwo: newAddress.address_line_two, AddressLineThree: newAddress.address_line_three, City: newAddress.city, PostCode: newAddress.postcode, Country: newAddress.country}
  } else {
     templateAddress = {AddressLineOne: newAddress.AddressLineOne, AddressLineTwo: newAddress.AddressLineTwo, AddressLineThree: newAddress.AddressLineThree, City: newAddress.City, PostCode: newAddress.PostCode, Country: newAddress.Country}
  }
  if (newAddress['County']){
    templateAddress['County'] = newAddress.County
  }
  newAddress.address = templateAddress
  delete newAddress['AddressLineOne']
    delete newAddress['AddressLineTwo']
    delete newAddress['AddressLineThree']
    delete newAddress['City']
    delete newAddress['PostCode']
    delete newAddress['County']
  if (addressType === 'customer' && methodType === 'create'){
    delete newAddress['Country']
      newAddress.lab_id = labId
  } else if (addressType === 'lab' && methodType === 'create') {
     delete newAddress['Country']
    if (newAddress.hasOwnProperty('organisation')){
      delete newAddress['Country']
      newAddress.organisation_id = newAddress['organisation']['id']
      delete newAddress['organisation']
      var dep_ids = [];
      if (newAddress.department_ids.length > 0){
        newAddress.department_ids.forEach(dep => {
            dep_ids.push(dep.id)
        })
        newAddress.department_ids = dep_ids
      }
    }
  } else if (addressType === 'lab' && methodType === 'edit') {
    delete newAddress['Country']
    if (newAddress.hasOwnProperty('organisation')){
      newAddress.organisation_id = newAddress['organisation']['id']
      delete newAddress['organisation']
    }
      dep_ids = [];
    
    if (newAddress.hasOwnProperty('department_ids') && newAddress.department_ids.length > 0){
      newAddress.department_ids.forEach(dep => {
          dep_ids.push(dep.id)
      })
      newAddress.department_ids = dep_ids
    }
    newAddress['notification_emails'] = [newAddress.notification_emails]
  }
  return newAddress
} 

export const shipmentDetailColumns =  [{property: 'Number',header: "Piece Number",primary: true},{property: 'Commodity',header: 'Commodity'},{property: 'Weight',header: 'Weight', units: '(KG)'},{property: 'Dimensions.Length',header: "Length", units: "(CM)"},{property: 'Dimensions.Width',header: "Width", units: "(CM)"},{property: 'Dimensions.Height',header:"Height", units: "(CM)"}]



export const QuoteData = (quote) => {
  return [{PieceNumber: quote.quote.transit_details.Packages[0].Number, Weight: quote.quote.total_actual_weight, Length: quote.quote.transit_details.Packages[0].Dimensions.Length, Width: quote.quote.transit_details.Packages[0].Dimensions.Width, Height: quote.quote.transit_details.Packages[0].Dimensions.Height}]
}

export const ShipmentDetailForm = [{name: 'commodity'},{name: 'weight', min: 0.5, placeholder: 'Enter Length', label: 'Weight (KG)', type:'number', icon:<Cube />},{name: 'length', min: 1, placeholder: 'Enter Length', label: 'Length (CM)', type:'number', icon:<ThreeD />},{name: 'width', min: 1, placeholder: 'Enter Width', label: 'Width (CM)', type:'number', icon:<ThreeD />},{name: 'height', min: 1, placeholder: 'Enter Height', label: 'Height (CM)', type:'number', icon:<ThreeD />},{name: 'customsValue', min: 1, placeholder: 'Enter Customs Value', label: 'Customs Value (USD)', type:'number', icon:<Currency />},{name: 'pieceRef', placeholder: 'Enter Piece Reference', label: 'Piece Reference', type:'input', icon:<Notes />}]

export const ShipmentQuoteDetailFormElements = [{name: 'quoted_weight', placeholder: 'Enter Weight', label: 'Weight (KG)', type:'float', icon:<Cube />},{name: 'length', min: 1, placeholder: 'Enter Length', label: 'Length (CM)', type:'number', icon:<ThreeD />},{name: 'width', min: 1, placeholder: 'Enter Width', label: 'Width (CM)', type:'number', icon:<ThreeD />},{name: 'height', min: 1, placeholder: 'Enter Height', label: 'Height (CM)', type:'number', icon:<ThreeD />}]

export const FilterLocations = (option,setLocations,allLocations) => {
  if (option.includes('all')){
    setLocations(allLocations)
    return allLocations
  } else if (option[0] === 'Address' && option.length === 1){
   var filteredLocations = [] 
   allLocations.filter(item => {
    if (item.location_type === 'Address'){
      filteredLocations.push(item)
    }
    return filteredLocations
   })
   setLocations(filteredLocations)
  } else if (option[0] === 'Customer' && option.length === 1){
    filteredLocations = [] 
    allLocations.filter(item => {
     if (item.location_type === 'Customer'){
       filteredLocations.push(item)
     }
     return filteredLocations
    })
    setLocations(filteredLocations)
   }else if (option[0] === 'Organisation' && option.length === 1){
      filteredLocations = [] 
    allLocations.filter(item => {
     if (item.location_type === 'Lab'){
       filteredLocations.push(item)
     }
     return filteredLocations
    })
    setLocations(filteredLocations)
   } else if (option.length === 3) {
    setLocations(allLocations)
   } else if (option.includes('Customer') && option.includes("Address")){
     filteredLocations = [] 
    allLocations.filter(item => {
     if (item.location_type === 'Customer' || item.location_type === 'Address'){
       filteredLocations.push(item)
     }
     return filteredLocations
    })
    setLocations(filteredLocations)
   }  else if (option.includes('Customer') && option.includes("Organisation")){
     filteredLocations = [] 
    allLocations.filter(item => {
     if (item.location_type === 'Customer' || item.location_type === 'Lab'){
       filteredLocations.push(item)
     }
     return filteredLocations
    })
    setLocations(filteredLocations)
   }
   else if (option.includes('Organisation') && option.includes("Address")){
    filteredLocations = [] 
    allLocations.filter(item => {
     if (item.location_type === 'Lab' || item.location_type === 'Address'){
       filteredLocations.push(item)
     }
     return filteredLocations
    })
    setLocations(filteredLocations)
   }
}